module.exports = __webpack_public_path__ + "img/task.3f8006f7.svg";